import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SpinnerLoader from "../../../components/SpinnerLoader";
import { updateLearnerApplicationStatus } from "../../../redux/slices/learner.applications.slice";
import { RootState, useAppDispatch } from "../../../redux/store";
import SaveConfirmModal from "../../../components/modal/SaveConfirmModal";
import EventDetailsModal from "../../Sessions/components/EventDetailsModal";
import {
  getHRApplications,
  updateHRApplicationStatus,
} from "../../../redux/slices/hr.applications.slice";
import HomeButton from "../../../components/HomeButton";
import Header from "../../../components/Header";
import TabNavbar from "../../../components/Tabbar";
import { HR_TABS } from "../../../utils/TabbarData";
import Pagination from "../../../components/Pagination";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "./components";
import { BsFilter } from "react-icons/bs";
import { FaX } from "react-icons/fa6";
const PRORITY_MAP: any = {
  NOT_SET: "No Priority",
  HIGH: "First Priority",
  TOP: "Second Priority",
};

const STATUS_MAP: any = {
  APPLIED: {
    label: "PENDING MANAGER CONFIRMATION",
    color: "bg-orange-500 text-white",
  },
  APPROVED_BY_MANAGER: {
    label: "CONFIRMED BY MANAGER",
    color: "bg-green-500 text-white",
  },
  WAITING: {
    label: "WAITING LIST",
    color: "bg-blue-500 text-white",
  },
  DRAFTED: {
    label: "DRAFTED",
    color: "bg-gray-500 text-white",
  },
  CONFIRMED_BY_LEARNER: {
    label: "SEAT CONFIRMED",
    color: "bg-green-500 text-white",
  },
  IN_PROGRESS: {
    label: "Session in Progress",
    color: "bg-purple-500 text-white",
  },
  REJECTED_BY_MANAGER: {
    label: "MANAGER DECLINED",
    color: "bg-red-500 text-white",
  },
  REJECTED_BY_LEARNER: {
    label: "USER DECLINED",
    color: "bg-red-500 text-white",
  },
  APPLICATION_REJECTED_BY_LEARNER: {
    label: "USER DECLINED",
    color: "bg-red-500 text-white",
  },
  ENDED: {
    label: "SESSION FINISHED",
    color: "bg-gray-500 text-white",
  },
  REJECTED_BY_TOA: {
    label: "DECLINED BY SYSTEM",
    color: "bg-red-500 text-white",
  },
  REJECTED_BY_HR: {
    label: "HR DECLINED",
    color: "bg-red-500 text-white",
  },
  CONFIRMED_BY_HR: {
    label: "CONFIRMED BY HR",
    color: "bg-green-500 text-white",
  },
  CONFIRMED_BY_MANAGER: {
    label: "CONFIRMED BY MANAGER",
    color: "bg-green-500 text-white",
  },
  HR_APPROVAL_PENDING: {
    label: "HR APPROVAL PENDING",
    color: "bg-orange-500 text-white",
  },
  APPROVED_BY_HR: {
    label: "HR APPROVED",
    color: "bg-green-500 text-white",
  },
  ELIGIBLE: {
    label: "Eligible",
    color: "bg-green-500 text-white",
  },
  NOT_ELIGIBLE: {
    label: "Not Eligible",
    color: "bg-gray-500 text-white",
  },
};

function CourseApplications() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const {
    hrApplicationLoading,
    appliedHRCourses,
    selectedCourseData,
    updateLoading,
  } = useSelector((state: RootState) => state.hrApplications);

  const [modalData, setModalData] = useState<any[]>([]); // Modal data for events
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
  const [isSaveModalOpen, setIsSaveModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentSeeionName, setCurrentSeeionName] = useState(null);
  const [filteredCourses, setFilteredCourses] =
    useState<any[]>(appliedHRCourses);
  const [currentPage, setCurrentPage] = useState(1); // Current page state
  const [itemsPerPage, setItemsPerPage] = useState(12);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState<any>(null);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [selectedCancelItem, setSelectedCancelItem] = useState<any>(null);
  const [courseNameFilter, setCourseNameFilter] = useState(""); // string input
  const [applicationStatusFilter, setApplicationStatusFilter] = useState(""); // string input
  const [fullNameFilter, setFullNameFilter] = useState(""); // string input
  const [sessionNameFilter, setSessionNameFilter] = useState(""); // string input
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [currentCourseName, setCurrentCourseName] = useState("");
  const [currentUserName, setCurrentUserName] = useState("");
  const [showNoSessions, setShowNoSessions] = useState(false);
  const [jobLevelFilter, setJobLevelFilter] = useState("");
  const [priorityFilter, setPriorityFilter] = useState("");
  const [categoryTypeFilter, setCategoryTypeFilter] = useState("");

  const location = useLocation();
  const isComingBackFromCourse =
    location.state?.from === "LearnerCourseSessions";
  // Open modal
  const openConfirmModal = (item: any) => {
    setIsConfirmModalOpen(true);
    setSelectedCourse(item);
    setCurrentCourseName(item?.course_name);
    setCurrentUserName(item?.user_name);
  };

  // Close modal
  const closeConfirmModal = () => {
    setIsConfirmModalOpen(false);
    setSelectedCourse(null);
    setCurrentCourseName("");
    setCurrentUserName("");
  };

  // Handle Confirm
  const handleConfirm = async () => {
    try {
      const payload = {
        user_id: selectedCourse.user_id,
        course_id: selectedCourse.course_id,
        application_status: "CONFIRMED_BY_HR",
      };

      await dispatch(updateHRApplicationStatus(payload));
      closeConfirmModal(); // Close modal
      await dispatch(getHRApplications({ status: "HR_APPLICATIONS" }));
    } catch (error) {
      console.error("Error confirming application:", error);
    }
  };

  // Handle Cancel/Reject
  const handleCancelApplication = async () => {
    try {
      const payload = {
        user_id: selectedCancelItem.user_id,
        course_id: selectedCancelItem.course_id,
        application_status: "REJECTED_BY_HR",
      };

      await dispatch(updateHRApplicationStatus(payload));
      setIsCancelModalOpen(false);
      setSelectedCancelItem(null);
      await dispatch(getHRApplications({ status: "HR_APPLICATIONS" }));
    } catch (error) {
      console.error("Error rejecting application:", error);
    }
  };

  const totalPages =
    filteredCourses?.length > 0
      ? Math.ceil(filteredCourses?.length / itemsPerPage)
      : 1;
  const paginatedData = filteredCourses?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const handleApply = async () => {
    const payload = {
      userId: sessionStorage.getItem("userId") || "",
      courseId: selectedCourseData?.course_id,
      status: "APPLIED",
    };

    await dispatch(updateLearnerApplicationStatus(payload));

    setIsSaveModalOpen(false);
    navigate("/learner/applied-trainings");
  };

  const fetchHRApplications = async () => {
    // dispatch(setEmptyAppliedCourses());
    await dispatch(getHRApplications({ status: "HR_APPLICATIONS" }));
  };
  useEffect(() => {
    fetchHRApplications();
  }, [dispatch]);

  useEffect(() => {
    setFilteredCourses(appliedHRCourses);
  }, [appliedHRCourses]);
  // Parse and set modal data for events

  const handleCloseModal = () => setIsModalOpen(false);

  const applyFilters = () => {
    let filteredData = appliedHRCourses;

    if (courseNameFilter !== "") {
      filteredData = filteredData.filter((course: any) =>
        course.course_name
          .toLowerCase()
          .includes(courseNameFilter.toLowerCase())
      );
    }

    // Filter by applicationStatusFilter (contains, case insensitive)
    if (applicationStatusFilter.trim() !== "") {
      filteredData = filteredData.filter(
        (course: any) =>
          course.application_status?.toUpperCase() ===
          applicationStatusFilter.trim().toUpperCase()
      );
    }

    if (fullNameFilter.trim() !== "") {
      const fullNameFilterValue = fullNameFilter.trim().toLowerCase();

      filteredData = filteredData.filter((course: any) => {
        const fullName = `${course.first_name ?? ""} ${course.last_name ?? ""}`
          .trim()
          .toLowerCase();
        return fullName.includes(fullNameFilterValue);
      });
    }

    // if (sessionNameFilter.trim() !== "") {
    //   filteredData = filteredData.filter((course: any) =>
    //     course?.session_name
    //       ?.toLowerCase()
    //       .includes(sessionNameFilter?.toLowerCase())
    //   );
    // }

    // Filter by session name or show no sessions
    if (sessionNameFilter.trim() !== "" || showNoSessions) {
      filteredData = filteredData.filter((course: any) => {
        const name = course.session_name?.toLowerCase() || "";
        const hasNoSession = !course.session_name || course.session_name === "";

        // If showNoSessions is true, only show items with no sessions
        if (showNoSessions && sessionNameFilter.trim() === "") {
          return hasNoSession;
        }

        // If sessionNameFilter is provided, filter by session name
        if (sessionNameFilter.trim() !== "") {
          return name.includes(sessionNameFilter.toLowerCase());
        }

        // If both are true, show items that match session name OR have no sessions
        return name.includes(sessionNameFilter.toLowerCase()) || hasNoSession;
      });
    }

    if (jobLevelFilter.trim() !== "") {
      filteredData = filteredData.filter((course: any) =>
        course.job_level.toLowerCase().includes(jobLevelFilter.toLowerCase())
      );
    }

    if (priorityFilter.trim() !== "") {
      filteredData = filteredData.filter((course: any) =>
        course.application_priority
          .toLowerCase()
          .includes(priorityFilter.toLowerCase())
      );
    }

    if (categoryTypeFilter.trim() !== "") {
      filteredData = filteredData.filter((course: any) =>
        course.category_type
          .toLowerCase()
          .includes(categoryTypeFilter.toLowerCase())
      );
    }

    setFilteredCourses(filteredData);
    setCurrentPage(1);
  };

  useEffect(() => {
    applyFilters();
  }, [
    // searchTerm,
    fullNameFilter,
    applicationStatusFilter,
    courseNameFilter,
    appliedHRCourses,
    sessionNameFilter,
    jobLevelFilter,
    priorityFilter,
    categoryTypeFilter,
    showNoSessions,
  ]);

  const courses = appliedHRCourses
    ?.map((course: any) => ({
      course_id: course.course_id,
      course_name: course.course_name,
    }))
    ?.filter(
      (course: any, index: any, self: any) =>
        index ===
        self.findIndex((t: any) => t.course_name === course.course_name)
    );

  // Parse and set modal data for events
  const handleOpenModal = (events: string) => {
    // Step 1: Split by "," only outside of "({ })"
    // const eventBlocks = events.split(/(?<=\)}),/); // Match ", " only outside the "({ })"
    const eventBlocks = events.split(/;\s*/);
    const parsedEvents = eventBlocks.map((block) => {
      // Step 2: Split by "({"
      const [eventName, detailsBlock] = block.split("{(");

      // Step 3: Remove closing ")}" and split details inside "({ })" by ","
      const details = detailsBlock
        ?.replace(")}", "")
        ?.split(",")
        .map((item) => item.trim());

      // Step 4: Map details to fields
      const [date, time, mode, location, classroom, ...instructorsBlock] =
        details || [];

      // Step 5: Clean instructors
      // Step 5: Extract and clean instructors
      const instructors = instructorsBlock
        .join(", ") // Join remaining parts to recreate full instructors string
        .replace("Instructors:", "") // Remove the "Instructors:" prefix
        .trim();

      return {
        eventName: eventName?.trim(),
        date: date || null,
        time: time
          ? time
              .split("-")
              .map((t) => t.trim().slice(0, 5))
              .join("-")
          : null,
        mode: mode || null,
        location: location || null,
        classroom: classroom || null,
        instructors: instructors || null,
      };
    });

    setModalData(parsedEvents);
    setIsModalOpen(true);
  };

  const isMobileOrTablet = window.innerWidth < 1024; // Checking for mobile/tablet screens

  return (
    <div className="flex flex-col items-start gap-8">
      {!isMobileOrTablet && <HomeButton />}
      {isMobileOrTablet ? (
        <>
          {" "}
          <TabNavbar
            id=""
            tabs={HR_TABS}
            selectedTabId={2}
            type="User Applications"
          />
          <HomeButton />
          <Header />
        </>
      ) : (
        <>
          <Header />
          <TabNavbar
            id=""
            tabs={HR_TABS}
            selectedTabId={2}
            type="User Applications"
          />{" "}
        </>
      )}

      <div
        className={`${
          isMobileOrTablet ? "flex flex-col" : "flex flex-row"
        } gap-4 w-full`}
      >
        {!isMobileOrTablet && (
          <button
            onClick={() => setIsFilterOpen(true)}
            className="px-4 py-2 bg-[#961e38] rounded hover:bg-[#961e38] text-white w-[8vw]"
          >
            {t("Filter")}
          </button>
        )}

        <div className="w-full flex justify-between items-center gap-2">
          {isMobileOrTablet && (
            <div>
              <button
                onClick={() => setIsFilterOpen(true)}
                className="px-4 py-2 bg-[#961e38] rounded hover:bg-[#961e38] text-white"
              >
                <BsFilter className="inline" />
              </button>
            </div>
          )}
        </div>
        {/* Filter Widget */}
        {isFilterOpen && (
          <div
            className={`absolute ${
              isMobileOrTablet ? "top-[42%]" : "top-[40%] left-[22%]"
            }  mt-2 bg-white shadow-lg rounded border w-80 p-4 z-50`}
            style={{ minWidth: "300px" }}
          >
            {/* Close button */}
            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-900"
              onClick={() => setIsFilterOpen(false)}
            >
              &#10005;
            </button>

            <div className="flex flex-col gap-2">
              {/* Application Status Dropdown */}
              <label>{t("Application Status")}</label>
              <select
                className="border p-2 rounded"
                value={applicationStatusFilter}
                onChange={(e) => {
                  setApplicationStatusFilter(e.target.value);
                }}
              >
                <option value="">{t("All")}</option>
                <option value="APPLIED">
                  {t("Manager Approval Pending")}
                </option>
                <option value="APPROVED_BY_MANAGER">
                  {t("Confirmed By Manager")}
                </option>
                <option value="WAITING">{t("Waiting List")}</option>
                <option value="CONFIRMED_BY_LEARNER">
                  {t("Seat Confirmed")}
                </option>
                <option value="REJECTED_BY_MANAGER">
                  {t("Denied By Manager")}
                </option>
                <option value="REJECTED_BY_LEARNER">
                  {t("Denied by Learner")}
                </option>
                <option value="REJECTED_BY_TOA">
                  {t("Denied by System")}
                </option>
                <option value="REJECTED_BY_HR">{t("HR DECLINED")}</option>
                <option value="CONFIRMED_BY_HR">{t("Confirmed by HR")}</option>
                <option value="HR_APPROVAL_PENDING">
                  {t("HR Approval Pending")}
                </option>
                <option value="APPROVED_BY_HR">{t("HR Approved")}</option>
                <option value="DRAFTED">{t("Drafted")}</option>
              </select>

              <label>{t("Course Name")}</label>
              <select
                className="border p-2 rounded"
                value={courseNameFilter}
                onChange={(e) => setCourseNameFilter(e.target.value)}
              >
                <option value="">{t("Select")}</option>
                {courses.map((course: any) => (
                  <option key={course.course_id} value={course.course_name}>
                    {course.course_name}
                  </option>
                ))}
              </select>

              <label>{t("Session Name")}</label>
              <input
                type="text"
                className="border p-2 rounded"
                placeholder={t("Session Name")}
                value={sessionNameFilter}
                onChange={(e) => {
                  setSessionNameFilter(e.target.value);
                }}
              />

              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={showNoSessions}
                  onChange={(e) => setShowNoSessions(e.target.checked)}
                />
                {t("No Sessions Yet")}
              </label>

              {/* Full Name Text */}
              <label>{t("Full Name")}</label>
              <input
                type="text"
                className="border p-2 rounded"
                placeholder={t("Full Name")}
                value={fullNameFilter}
                onChange={(e) => {
                  setFullNameFilter(e.target.value);
                }}
              />

              <label>{t("Career Level")}</label>
              <input
                type="text"
                className="border p-2 rounded"
                placeholder={t("Enter Career Level")}
                value={jobLevelFilter}
                onChange={(e) => setJobLevelFilter(e.target.value)}
              />

              <label>{t("Priority")}</label>
              <select
                className="border p-2 rounded"
                value={priorityFilter}
                onChange={(e) => setPriorityFilter(e.target.value)}
              >
                <option value="">{t("Select...")}</option>
                <option value="NOT_SET">{t("No Priority")}</option>
                <option value="TOP">{t("Second Priority")}</option>
                <option value="HIGH">{t("First Priority")}</option>
              </select>

              <label>{t("Course Type")}</label>
              <select
                className="border p-2 rounded"
                value={categoryTypeFilter}
                onChange={(e) => setCategoryTypeFilter(e.target.value)}
              >
                <option value="">{t("Select Category Type")}</option>
                <option value="LOCAL">{t("LOCAL")}</option>
                <option value="GROUP">{t("GROUP")}</option>
              </select>

              <button
                className="mt-2 text-sm bg-[#961e38] text-white py-2 px-4 rounded"
                onClick={() => {
                  setCourseNameFilter("");
                  setFullNameFilter("");
                  setSessionNameFilter("");
                  setApplicationStatusFilter("");
                  setJobLevelFilter("");
                  setPriorityFilter("");
                  setCategoryTypeFilter("");
                  setShowNoSessions(false);
                }}
              >
                {t("Clear Filters")}
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Mobile/Tablet View */}
      <div className="block md:hidden w-full h-full">
        {hrApplicationLoading ? (
          <div className="flex items-center w-full justify-center mt-4 mb-4">
            <SpinnerLoader />
          </div>
        ) : paginatedData?.length > 0 ? (
          paginatedData.map((item, i) => {
            return (
              <div
                key={i}
                className="border border-[#c6c6c6] py-2 text-left bg-[#f3f3f3] mt-2"
              >
                <div className="px-4 border-b border-[#c6c6c6] pb-2">
                  <h3 className="font-[600] pb-2"> {t("Full Name")}</h3>
                  <p className="text-lg">
                    {item?.first_name + " " + item?.last_name}
                  </p>
                </div>
                <div className="px-4 border-b border-[#c6c6c6] pb-2">
                  <h3 className="font-[600] pb-2"> {t("Language")}</h3>
                  <p className="text-lg">
                    {" "}
                    {item?.drafted_session_id
                      ? item?.session_language
                        ? item?.session_language
                        : "NOT AVAILABLE"
                      : t("TBD")}
                  </p>
                </div>
                <div className="px-4 border-b border-[#c6c6c6] pb-2">
                  <h3 className="font-[600] pb-2">{t("Course Type")}</h3>
                  <p className="text-lg">{t(item?.category_type)}</p>
                </div>
                <div className="px-4 border-b border-[#c6c6c6] pb-2">
                  <h3 className="font-[600] pb-2">{t("Learner Job Level")}</h3>
                  <p className="text-lg">{item?.job_level}</p>
                </div>
                <div className="px-4 border-b border-[#c6c6c6] pb-2">
                  <h3 className="font-[600] pb-2"> {t("Course Name")}</h3>
                  <p className="text-lg">{item?.course_name}</p>
                </div>
                <div className="px-4 border-b border-[#c6c6c6] pb-2">
                  <h3 className="font-[600] pb-2">{t("Session Details")}</h3>
                  <p className="text-lg">
                    {item?.drafted_session_id ? (
                      <span
                        className="text-blue-500 cursor-pointer underline"
                        onClick={() => {
                          setCurrentSeeionName(item?.session_name);
                          handleOpenModal(item?.events);
                        }}
                      >
                        {t("Open")}
                      </span>
                    ) : (
                      "TBD"
                    )}
                  </p>
                </div>
                <div className="px-4 border-b border-[#c6c6c6] pb-2">
                  <h3 className="font-[600] pb-2">{t("Application Status")}</h3>
                  <div className="text-lg">
                    {item?.application_status === "DRAFTED" ? (
                      <button
                        onClick={() => openConfirmModal(item)}
                        className="px-4 py-1 border border-green-500 text-green-600 rounded-md bg-white hover:bg-green-50 transition"
                      >
                        {t("Confirm")}
                      </button>
                    ) : (
                      <div
                        className={`min-w-[10rem] text-sm p-2 text-center rounded ${
                          STATUS_MAP[item?.application_status]?.color ||
                          "bg-red-500 text-white"
                        }`}
                      >
                        {t(
                          STATUS_MAP[item?.application_status]?.label || t("N/A")
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="px-4 border-b border-[#c6c6c6] pb-2">
                  <h3 className="font-[600] pb-2">{t("Priority")}</h3>
                  <p className="text-lg">
                    {t(PRORITY_MAP[item?.application_priority])}
                  </p>
                </div>
                {item?.application_status !== "REJECTED_BY_MANAGER" &&
                  item?.application_status !== "REJECTED_BY_LEARNER" &&
                  item?.application_status !== "REJECTED_BY_TOA" &&
                  item?.application_status !== "REJECTED_BY_HR" &&
                  item?.application_status !== "APPLICATION_REJECTED_BY_LEARNER" && (
                    <div className="px-4 border-b border-[#c6c6c6] pb-2 flex justify-center">
                      <button
                        className="p-2 text-red-500 hover:text-red-700"
                        onClick={() => {
                          setSelectedCancelItem(item);
                          setIsCancelModalOpen(true);
                        }}
                      >
                        <FaX size={20} />
                      </button>
                    </div>
                  )}
              </div>
            );
          })
        ) : (
          <p className="w-full text-center py-5">
            {t("No Application Data found")}
          </p>
        )}
      </div>

      {/* Desktop View */}
      <div className="hidden md:block w-full h-full">
        <table className="table-auto w-full">
          <thead>
            <tr className="bg-[#A6192E] text-white">
              <th className="border-b border-[#961e38] py-2 px-4 w-1/5 text-center">
                {t("Full Name")}
              </th>
              <th className="border-b border-[#961e38] py-2 px-4 w-1/5 text-center">
                {t("Language")}
              </th>
              <th className="border-b border-[#961e38] py-2 px-4 w-1/5 text-center">
                {t("Course Type")}
              </th>
              <th className="border-b border-[#961e38] py-2 px-4 w-1/5 text-center">
                {t("Learner Job Level")}
              </th>
              <th className="border-b border-[#961e38] py-2 px-4 w-1/5 text-center">
                {t("Course Name")}
              </th>
              <th className="border-b border-[#961e38] py-2 px-4 w-1/5 text-center">
                {t("Session Details")}
              </th>

              <th className="border-b border-[#961e38] py-2 px-4 w-1/5 text-center">
                {t("Application Status")}
              </th>
              <th className="border-b border-[#961e38] py-2 px-4 w-1/5 text-center">
                {t("Priority")}
              </th>
              <th className="border-b border-[#961e38] py-2 px-4 text-center w-auto"></th>
            </tr>
          </thead>
          <tbody>
            {hrApplicationLoading ? (
              <tr>
                <td colSpan={9} className="text-center">
                  <div className="flex items-center w-full justify-center mt-4 mb-4">
                    <SpinnerLoader />
                  </div>
                </td>
              </tr>
            ) : (
              <>
                {paginatedData?.length > 0 ? (
                  <>
                    {paginatedData?.map((item: any, i: any) => (
                      <tr key={i}>
                        <td className="border-b border-[#c6c6c6] py-2 px-4 text-center w-1/5">
                          {item?.first_name + " " + item?.last_name}
                        </td>
                        <td className="border-b border-[#c6c6c6] py-2 px-4 text-center w-1/5">
                          {item?.drafted_session_id
                            ? item?.session_language
                              ? item?.session_language
                              : "NOT AVAILABLE"
                            : t("TBD")}
                        </td>
                        <td className="border-b border-[#c6c6c6] py-2 px-4 text-center w-1/5">
                          {t(item?.category_type)}
                        </td>
                        <td className="border-b border-[#c6c6c6] py-2 px-4 text-center w-1/5">
                          {item?.job_level}
                        </td>
                        <td className="border-b border-[#c6c6c6] py-2 px-4 text-center w-1/5">
                          {item?.course_name}
                        </td>
                        <td className="border-b border-[#c6c6c6] py-2 px-4 text-center w-1/5">
                          {item?.drafted_session_id ? (
                            <span
                              className="text-blue-500 cursor-pointer underline"
                              onClick={() => {
                                setCurrentSeeionName(item?.session_name);
                                handleOpenModal(item?.events);
                              }}
                            >
                              {t("Open")}
                            </span>
                          ) : (
                            "TBD"
                          )}
                        </td>
                        <td
                          className={`border-b border-[#c6c6c6] py-2 px-4 text-center w-1/5`}
                        >
                          {item?.application_status === "DRAFTED" ? (
                            <button
                              onClick={() => openConfirmModal(item)}
                              className="px-4 py-1 border border-green-500 text-green-600 rounded-md bg-white hover:bg-green-50 transition"
                            >
                              {t("Confirm")}
                            </button>
                          ) : (
                            <div
                              className={`min-w-[10rem] text-sm p-2 text-center rounded ${
                                STATUS_MAP[item?.application_status]?.color ||
                                "bg-red-500 text-white"
                              }`}
                            >
                              {STATUS_MAP[item?.application_status]?.label
                                ? t(STATUS_MAP[item?.application_status].label)
                                : t("N/A")}
                            </div>
                          )}
                        </td>
                        <td className="border-b border-[#c6c6c6] py-2 px-4 text-center w-1/5">
                          {t(PRORITY_MAP[item?.application_priority])}
                        </td>
                        <td className="border-b border-[#c6c6c6] py-2 px-4 text-center w-auto">
                          {item?.application_status !== "REJECTED_BY_MANAGER" &&
                            item?.application_status !== "REJECTED_BY_LEARNER" &&
                            item?.application_status !== "REJECTED_BY_TOA" &&
                            item?.application_status !== "REJECTED_BY_HR" &&
                            item?.application_status !== "APPLICATION_REJECTED_BY_LEARNER" && (
                              <button
                                className="p-2 text-red-500 hover:text-red-700"
                                onClick={() => {
                                  setSelectedCancelItem(item);
                                  setIsCancelModalOpen(true);
                                }}
                              >
                                <FaX size={20} />
                              </button>
                            )}
                        </td>
                      </tr>
                    ))}
                  </>
                ) : (
                  <tr className="pt-5">
                    <td colSpan={9} className="text-center">
                      {t("No Application Data found")}
                    </td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </table>
      </div>
      <EventDetailsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        modalData={modalData}
        modalName="Session Details"
        sessionName={currentSeeionName}
      />
      {hrApplicationLoading === false && (
        <Pagination
          totalPages={totalPages}
          _currentPage={currentPage}
          _itemsPerPage={itemsPerPage}
          total_item_count={filteredCourses?.length}
          handleChange={({ page, itemsPerPage }) => {
            setCurrentPage(page);
            setItemsPerPage(itemsPerPage);
          }}
          isCoursePage={true}
        />
      )}
      {isSaveModalOpen && (
        <SaveConfirmModal
          closeModal={() => setIsSaveModalOpen(false)}
          handleSave={handleApply}
          msg="Are you sure you want to apply for this course?"
        />
      )}
      {/* Use the ConfirmationModal */}
      <ConfirmationModal
        isOpen={isConfirmModalOpen}
        onClose={() => {
          closeConfirmModal();
          setCurrentCourseName("");
          setCurrentUserName("");
        }}
        onConfirm={handleConfirm}
        loading={updateLoading}
        message={
          t(`Are you sure you want to confirm the application of`) +
          " " +
          currentUserName +
          " " +
          t("for") +
          " " +
          currentCourseName +
          "?"
        }
      />
      {/* Cancel/Reject Confirmation Modal */}
      {isCancelModalOpen && selectedCancelItem && (
        <SaveConfirmModal
          closeModal={() => {
            setIsCancelModalOpen(false);
            setSelectedCancelItem(null);
          }}
          handleSave={handleCancelApplication}
          loading={updateLoading}
          saveBtnText={t("DELETE APPLICATION")}
          cancleBtnText={t("GO BACK")}
          msg={t("As an HR Employee, you can only delete [LEARNER NAME]'s application fully for [COURSE NAME]. If [LEARNER NAME] wishes to reject a seat they were offered, they should do so themselves on their Application Status page.")
            .replace(/\[LEARNER NAME\]/g, `<strong>${selectedCancelItem?.first_name} ${selectedCancelItem?.last_name}</strong>`)
            .replace("[COURSE NAME]", `<strong>${selectedCancelItem?.course_name}</strong>`)}
        />
      )}
    </div>
  );
}

export default CourseApplications;
